import React, { useState, useEffect } from 'react';
import ProjectCard from '../Atoms/ProjectCard';
import ModalProject from './Modal';
import Modal from 'react-bootstrap/Modal';
import Form from './Form';
import SubscriptionInformation from '../Molecules/SubscriptionInformation';
import InputText from '../Atoms/InputText';
import IntakeWizard from './IntakeWizard';

function ModalConfirmRemove({ active, remove, close, setValue, value, alert = "" }) {
    return (
        <>
            <Modal size="lg" className="modal-remove" show={active} onHide={close} backdrop="static" centered>
                <Modal.Header  >
                </Modal.Header>
                <Modal.Body className=''>
                    <div className='delete-text'>
                        <img src="../images/warningAlert.png" width={300}></img>
                        <h4 className='d-none d-md-block'>Are you sure you want to delete this project? This action cannot be undone.</h4>
                        <h5 className='d-block d-md-none'>Are you sure you want to delete this project? This action cannot be undone.</h5>
                        <span>You must enter your password to confirm.</span>
                        {alert &&
                            <div className='alert alert-danger'>
                                <span>{alert}</span>
                            </div>
                        }
                        <div className='d-flex flex-row justify-content-center w-100 mt-3 input-modal-remove'>
                            <InputText label={""} name={"Password"} type={'password'} value={value} onChange={(e) => { setValue(e) }} placeholder={"Enter Password Account"} />
                        </div>
                        <div className='d-flex flex-column flex-md-row justify-content-end container-button-group mt-3'>
                            <button className='btn btn-primary mr-2' onClick={remove}>Confirm</button>
                            <button className='btn btn-secondary mr-2' onClick={close}>Cancel</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

const ProjectList = ({ projects, loading, setIsSelectedProject, setProjectName, selectProject, addProject, removeProject, editProject, subscription = { plan: 'no-plan' }, userEmail, onlyTemplates, isProjectManager, selectedPage, updatePage, newTemplateFromProject = false, setNewTemplateFromProject, newTemplateFromProjectData = {}, showProjectForm = false }) => {


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
    const [formMode, setFormMode] = useState('create');
    const [projectType, setProjectType] = useState('project');
    const [project, setProject] = useState(false);
    const [canCreateProject, setCanCreateProject] = useState(false);
    const [inputPasswordValue, setInputPasswordValue] = useState("");
    const [textAlertRemove, setTextAlertRemove] = useState("");
    const [isWizardOpen, setIsWizardOpen] = useState(false);

    useEffect(() => {

        const totalProjects = projects.filter(project => !project.is_template).length;

        if ((subscription.plan === 'Basic' && totalProjects < 3) || (subscription.plan === 'Free' && totalProjects < 1)) {
            setCanCreateProject(true)
        }
        return () => {
            setCanCreateProject(false)
        }
    }, [projects])

    useEffect(() => {
        if (newTemplateFromProject) {
            handleOpenModal('create', newTemplateFromProjectData, 'template');
            setNewTemplateFromProject(false);
        }
    }, [newTemplateFromProject])

    useEffect(() => {
        if (showProjectForm) {
            setIsWizardOpen(true);
            //handleOpenModal('create', project, 'project');           
        }
    }, [showProjectForm])

    const handleOpenModal = (mode, project = null, projectType = 'project') => {
        setFormMode(mode);
        setProject(project)
        setProjectType(projectType);
        setIsModalOpen(true);
    }

    const handleCloseModal = () => {
        setProject("");
        setIsModalOpen(false);
    };

    const handleCloseRemoveModal = () => {
        setProject("");
        setInputPasswordValue("");
        setShowRemoveConfirm(false);
    };

    const handleClickProject = (item) => {

        selectProject(item);
        setIsSelectedProject(item.id);
        setProjectName(!onlyTemplates ? item.name : item.project_template_name);
        setProject({
            id: item.id,
            name: item.name,
            zip_code: item.zip_code,
            gross_area: item.gross_area,
            work_type: item.work_type,
            main_building_use: item.main_building_use,
        })
    }

    const handleSave = (data) => {
        setProject(data);
        addProject(data);
        if (selectedPage === "Projects" && data.is_template) {
            updatePage('Templates');
        }
        setIsModalOpen(false);
        setIsWizardOpen(false);
    };

    const handleUpdate = (data) => {
        let bodyData = {
            project_data: data
        }
        setProject(data);
        editProject(data.id, bodyData);
        setIsModalOpen(false);
    };

    const handleShowRemoveProject = (data) => {
        setProject(data);
        setShowRemoveConfirm(true);
        //removeProject(data.id);
    }

    const handleRemoveProject = async () => {
        // setProject(data);

        let response = await removeProject(project.id, { data: { password: inputPasswordValue } });
        if (response.status === 'Success') {
            setShowRemoveConfirm(false);
            setProject(false);
            setTextAlertRemove("");
        } else {
            setTextAlertRemove('Authentication error, please try again.');
        }
        setInputPasswordValue("");

    }


    const handleEditProject = (data) => {
        handleOpenModal('edit', data);
    }

    const handleChangeInputRemove = (e) => {
        setInputPasswordValue(e.target.value);
    }

    if (isWizardOpen) {
        return (
            <IntakeWizard
                onCancel={() => setIsWizardOpen(false)}
                onSave={(wizardData) => {
                    // Aquí mapeas la data del Wizard al formato que espera tu función addProject
                    const formattedData = {
                        name: wizardData.projectName,
                        zip_code: wizardData.zipcode,
                        gross_area: wizardData.grossArea,
                        work_type: wizardData.sector, // Asumiendo mapeo
                        main_building_use: wizardData.deliveryMethod, // Asumiendo mapeo
                        is_template: false,

                        // --- 2. NUEVOS CAMPOS: LÍNEA BASE (KB Layer 0) ---
                        delivery_method: wizardData.deliveryMethod,
                        total_project_cost: wizardData.budget,

                        // --- 3. NUEVOS CAMPOS: MATRIZ DE COMPLEJIDAD (Extrayendo del objeto 'complexities') ---
                        complexity_f2_org_gov: wizardData.complexities.f2,
                        complexity_f3_tech_eng: wizardData.complexities.f3,
                        complexity_f4_site_ops: wizardData.complexities.f4,
                        complexity_f5_def_est: wizardData.complexities.f5,
                        complexity_f6_schedule: wizardData.complexities.f6,
                        complexity_f7_strat_vis: wizardData.complexities.f7,

                        // --- 4. NUEVOS CAMPOS: EVIDENCIA (KB Layer 6) ---
                        complexity_evidence: wizardData.evidence
                    };
                    handleSave(formattedData);
                }}
            />
        );
    }


    return (
        <div>

            <ModalProject
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                title={formMode === 'create' ? selectedPage === "Templates" ? "New Template" : "New Project" : selectedPage === "Templates" ? "Edit Template" : "Edit Project"}
                onSave={handleSave}
                onCancel={handleCloseModal}
            >
                <Form
                    mode={formMode}
                    initialData={project}
                    onSubmit={formMode === 'create' ? handleSave : handleUpdate}
                    onCancel={handleCloseModal}
                    isProjectManager={isProjectManager}
                    projectType={projectType}
                    selectedPage={selectedPage}
                />
            </ModalProject>

            <ModalConfirmRemove
                active={showRemoveConfirm}
                setValue={handleChangeInputRemove}
                remove={handleRemoveProject}
                close={handleCloseRemoveModal}
                value={inputPasswordValue}
                alert={textAlertRemove}
            />
            <div className='d-flex justify-content-between align-items-center'>
                {/* Modificamos el onClick para abrir el Wizard en lugar del Modal */}
                {(canCreateProject && !onlyTemplates) && (
                    <i
                        className="bi bi-plus-circle-fill"
                        style={{ fontStyle: 'normal', cursor: 'pointer', color: 'rgb(255 255 255)', backgroundColor: '#1a67a3', padding: '5px 20px', borderRadius: '5px' }}
                        onClick={() => setIsWizardOpen(true)}
                    >
                        New Project
                    </i>
                )}

                {/* Los Templates se siguen creando a través del Modal original */}
                {(canCreateProject && onlyTemplates) && (
                    <i
                        className="bi bi-plus-circle-fill"
                        style={{ fontStyle: 'normal', cursor: 'pointer', color: 'rgb(255 255 255)', backgroundColor: '#1a67a3', padding: '5px 20px', borderRadius: '5px' }}
                        onClick={() => handleOpenModal('create', project, 'template')}
                    >
                        New Template
                    </i>
                )}
                <span></span>
            </div>


            {loading ? (
                <p>Loading projects...</p>
            ) : (
                <div className="container-project mt-3 " >
                    {projects.length > 0 ? (
                        projects
                            .filter(project => onlyTemplates ? project.is_template : !project.is_template)
                            .map((project, index) => (
                                <div key={index} className="container-project-item">
                                    <ProjectCard
                                        {...project}
                                        selectProject={() => handleClickProject(project)}
                                        removeProject={() => handleShowRemoveProject(project)}
                                        editProject={() => handleEditProject(project)}
                                        subscription={subscription}
                                    />
                                </div>
                            ))
                    ) : (
                        <p>You don't have any projects created yet. Start a new one</p>
                    )}
                    <div className='d-block d-md-none'>
                        {subscription.plan === 'Free' &&
                            <SubscriptionInformation userEmail={userEmail} />
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProjectList